import React, { useState } from 'react';
import FloqTabs from '../../../components/Tabs/FloqTabs';
import InstitutionInfoTab from '../components/InstitutionInfoTab';
import { default as MUIButton } from '@mui/material/Button/Button';
import { useInstitutionProposalTabsStore } from '../stores/InstitutionProposalTabsStore';
import { CircularProgress } from '@mui/material';

export const tabs = [
    {
        label: 'Info',
        component: <InstitutionInfoTab />,
    },
    {
        label: 'Meetings',
        component: <div>Meetings</div>,
    },
    {
        label: 'Leads',
        component: <div>Leads</div>,
    },
    {
        label: 'Analytics',
        component: <div>Analytics</div>,
    },
];

const InstitutionProposal = () => {
    const isSubmitButtonLoading = useInstitutionProposalTabsStore(
        state => state.submitButtonLoading,
    );
    const isSubmitButtonDisabled = useInstitutionProposalTabsStore(
        state => state.submitButtonDisabled,
    );
    const submitButtonOnClick = useInstitutionProposalTabsStore(state => state.onSubmitButtonClick);
    const [activeTabIndex, setActiveTabIndex] = useState(0);

    const onTabChange = index => {
        setActiveTabIndex(index);
    };

    const handleSubmitButtonClick = () => {
        if (typeof submitButtonOnClick === 'function') {
            submitButtonOnClick();
        }
    };

    return (
        <>
            <FloqTabs
                data={tabs}
                activeIndex={activeTabIndex}
                onChange={onTabChange}
                TabBarRightComponent={
                    <MUIButton
                        onClick={handleSubmitButtonClick}
                        disabled={isSubmitButtonDisabled}
                        variant="contained"
                        sx={{ height: 40, marginTop: 0.5 }}
                    >
                        {isSubmitButtonLoading ? (
                            <CircularProgress size={20} />
                        ) : (
                            'Submit for approval'
                        )}
                    </MUIButton>
                }
            />
        </>
    );
};

export default InstitutionProposal;
